import { render, staticRenderFns } from "./DxManualPerformance.vue?vue&type=template&id=482150fe&"
import script from "./DxManualPerformance.vue?vue&type=script&lang=js&"
export * from "./DxManualPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports